export default "__VITE_PUBLIC_ASSET__eaa0902b__"